module.exports = __webpack_public_path__ + "static/ingo-med-center-2e612587eee1e5bcfdf0531bfcf92e0f.png";